<template>
  <div>
    <iframe
      :style="`height: ${getScrollHeight()} border: 0`"
      class="wd-100p"
      :src="task.taskEn"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getScrollHeight() {
      let mh = 170;
      if (screen.width <= 1024) {
        mh = 80;
      }
      return `calc(${window.innerHeight}px - ${mh}px);`;
    }
  }
};
</script>

<style></style>
